import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-0 text-white"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString("Sin Tickets"))
const _hoisted_4 = { class: "my-2 d-flex justify-content-center" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Ticket cerrado ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Iniciar Ticket ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exchange-alt",
  style: {"color":"var(--chat-bg-color-button)"}
}, null, -1)

import { socket } from "@/main";
import { computed, onMounted, onUnmounted, reactive, ref, watch } from "vue";
import Message from "./Message.vue";
import { useRoute } from "vue-router";
import RoomItem from "./RoomItem.vue";
import RoomSearch from "./RoomSearch.vue";
import RoomOptions from "./RoomOptions.vue";
import { getInitials, messageListObserver } from "@/util/utils";
import { textMessages } from "@/util/consts";
import DetailTicket from "./DetailTicket.vue";
import { AuthModule } from "@/store/modules/Auth";
import { TicketModule } from "@/store/modules/Ticket";
import "vue-advanced-chat/dist/vue-advanced-chat.css";
import { MessageModule } from "@/store/modules/Message";
import {
	CustomAction,
	CustomActions,
	Message as IMessage,
	MessagePayload,
	Room,
	StringNumber,
} from "vue-advanced-chat";
import ChatWindow from "vue-advanced-chat/src/lib/ChatWindow.vue";
import { AppModule } from "@/store/modules/app";
import { ModalSidebarState as ModalState } from "@/types/components";
import Loader from "vue-advanced-chat/src/components/Loader/Loader.vue";
import { closeTicket } from "@/store/actions/ticket.actions";
import { Filters } from "@/types/control";
import { coreApi } from "@/conection";
import { ConversationModule } from "@/store/modules/Conversation";
import TemplatesControl from "./templates/control.vue";
import { IdentificationModule } from "@/store/modules/Identification";

// Interfaces

interface IFoundMessage {
	_id: string;
	ticket: string;
	message: string;
	agent?: string;
	client?: string;
	interface: string;
	date: string;
}
// Data

export default /*#__PURE__*/_defineComponent({
  emits: ["changeModalStartTicket", "previewMedia"],
  setup(__props, { emit: emits }: { emit: ({
	(e: "changeModalStartTicket", t: ModalState): void;
	(e: "previewMedia", t: ModalState<{ message: IMessage }>): void;
}), expose: any, slots: any, attrs: any }) {

const lastMessageSending = ref(false);
const _height = ref(window.innerHeight - 109);
const reopenTicket = ref(false);
const route = useRoute();
const textareaRef = ref<HTMLTextAreaElement | null>(null);
const observer = ref<IntersectionObserver>();
const LoaderBottomRef = ref<Element | null>(null);
const autoScrollOptions = reactive({
	send: {
		new: true,
		newAfterScrollUp: true,
	},
	receive: {
		new: true,
		newAfterScrollUp: false,
	},
});



// Listeners
window.addEventListener(
	"resize",
	() => (_height.value = window.innerHeight - 79)
);

// Computed properties
const rooms = ref(TicketModule.Rooms);
const roomActions = computed<CustomActions>(() => {
	if (
		showFooter.value || // if show footer is active
		ConversationModule.showControl // or if control template is enabled
	)
		return [
			{
				name: "openPanel",
				title: TicketModule.openedSidebar ? "Cerrar Panel" : "Abrir Panel",
			},
			{
				name: "closeTicket",
				title: "Cerrar Ticket",
			},
			{
				name: "archived",
				customTitle: (room: Room) =>
					room.archived ? "Desarchivar" : "Archivar",
				title: `${
					TicketModule.currentTicket?.archived ? "Desarchivar" : "Archivar"
				}`,
			},
			{
				name: "pinned",
				customTitle: (room: Room) => (room.pinned ? "Desanclar" : "Anclar"),
				title: `${TicketModule.currentRoom?.pinned ? "Desanclar" : "Anclar"}`,
			},
		];
	else if (TicketModule.Filter === "closed")
		return [
			{
				name: "openPanel",
				title: TicketModule.openedSidebar ? "Cerrar Panel" : "Abrir Panel",
			},
		];
	else if (TicketModule.Filter === "archived")
		return [
			{
				name: "openPanel",
				title: TicketModule.openedSidebar ? "Cerrar Panel" : "Abrir Panel",
			},
			{
				name: "archived",
				customTitle: (room: Room) =>
					room.archived ? "Desarchivar" : "Archivar",
				title: `${
					TicketModule.currentTicket?.archived ? "Desarchivar" : "Archivar"
				}`,
			},
		];
	else if (TicketModule.Filter === Filters.BOT)
		return [
			{
				name: "openPanel",
				title: TicketModule.openedSidebar ? "Cerrar Panel" : "Abrir Panel",
			},
			/* 			{
				name: "claimed",
				title: "Reclamar",
			}, */
		];

	return [];
});
const messages = computed(() =>
	MessageModule.loadingMoreMessage || MessageModule.loaded
		? MessageModule.getMessages
		: []
);
const currentUserId = computed(() => AuthModule.id);
const height = computed(() => {
	return `${_height.value}px`;
});
const showFooter = computed(
	() => TicketModule.Filter === "claimed" && !ConversationModule.showControl
);
const roomUsers = computed(() => MessageModule.usersColors);
const showBottomLoader = computed(() => {
	return (
		MessageModule.lastMessage &&
		MessageModule.lastMessage?._id !==
			TicketModule.currentTicket?.last_msg._id &&
		!lastMessageSending.value
	);
});
const privateReplyStatus = computed<boolean>(
	() => TicketModule.privateReplyStatus
);
// Methods

async function fetchOldTicket(message: IFoundMessage) {
	if (!TicketModule.LastTickets.find(t => t._id === message.ticket)) {
		const response = await coreApi.post(`api/ticket/search/${message.ticket}`);
		TicketModule.lastTicketUpsert(response.data.ticket);
	}

	TicketModule.previewOldTicket({
		ticketId: message.ticket,
		date: message.date,
	});
}
function setFilter() {
	if (route.params.option === "unassigned")
		TicketModule.setFilter(Filters.OPEN);
	else if (route.params.option === "assigned")
		TicketModule.setFilter(Filters.CLAIMED);
	else if (route.params.option === "bot") TicketModule.setFilter(Filters.BOT);
	else if (route.params.option === "overview")
		TicketModule.setFilter(Filters.OVERVIEW);
}
function fetchMessages({
	room,
	options,
}: {
	room: Room;
	options?: { reset: boolean };
}) {
	if (!options?.reset) return;
	if (!TicketModule.searchSidebar)
		MessageModule.deleteFromTicket(TicketModule.currentRoomID ?? "");
	setTimeout(async () => {
		if (!options?.reset) return;
		if (
			!AuthModule.token ||
			(room.roomId === TicketModule.currentRoomID &&
				options?.reset &&
				MessageModule.loading)
		)
			return;
		if (
			!TicketModule.currentRoomID &&
			!(await TicketModule.ticketExists(room.roomId))
		)
			return;
		const client = room.users[0]._id + "";
		if (options?.reset) TicketModule.setActualRoom(room.roomId);
		MessageModule.requestTicketsFromClient({ token: AuthModule.token, client });
		MessageModule.requestMessages({
			token: AuthModule.token,
			ticket: room.roomId,
			date: !options?.reset
				? MessageModule.getMessages?.[0]?.isoDate
				: undefined,
			reset: !!options?.reset,
		});
		IdentificationModule.requestFoundCoincidences({
			client: client,
			identifications: room.users[0].identifications ?? [],
		});
		if (
			(showFooter.value && options?.reset) ||
			TicketModule.Filter === "closed"
		)
			setTimeout(() => {
				TicketModule.setOpenedSearchSidebar(false);
				TicketModule.setOpenedSidebar(AppModule.userSettings.showSidebar);
			});
	});
}

async function fetchRooms() {
	if (AuthModule.token)
		TicketModule.requestPageTickets({ token: AuthModule.token });
}

async function setNewestTicket() {
	autoScrollOptions.send.new = true;
	autoScrollOptions.receive.new = true;
	socket.emit("LEAVE_ROOM", {
		token: AuthModule.token,
		ticketID: TicketModule.currentRoomID,
	});
	await TicketModule.setActualRoom(TicketModule.CurrentNewestRoom.id);
	MessageModule.requestMessages({
		token: AuthModule.token ?? "",
		reset: true,
		ticket: TicketModule?.CurrentNewestRoom.id ?? "",
	});
}

function claimTicket() {
	socket.emit("TICKET_CLAIM_BY_ID", {
		token: AuthModule.token,
		ticketID: TicketModule.currentRoomID,
	});
}

function messageActionHandler({
	action,
	message,
}: {
	roomId: StringNumber;
	action: CustomAction;
	message: IMessage;
}) {
	if (action.name === "downloadMedia") {
		message.files?.forEach(file => {
			const aElement = document.createElement("a");
			aElement.id = `download-${message.id}-${file.name}`;
			aElement.setAttribute("download", file.name);
			aElement.href = file?.url ?? "";
			aElement.setAttribute("target", "_blank");
			aElement.click();
		});
	} else if (action.name === "go-to-reply") {
		fetchOldTicket({
			_id: message.replyMessage?._id.toString() ?? "",
			date: message.replyMessage?.isoDate ?? "",
			interface: "_",
			message: message.replyMessage?._id.toString() ?? "",
			ticket: message.replyMessage?.roomId ?? "",
		});
		// console.log(message);
	}
}
function actionHandler({
	roomId,
	action,
}: {
	roomId: StringNumber;
	action: CustomAction;
}) {
	if (!AuthModule.token) return;
	switch (action.name) {
		case "closeTicket":
			closeTicket(roomId.toString());
			break;
		case "openPanel":
			setTimeout(() => {
				TicketModule.setOpenedSearchSidebar(false);
				TicketModule.setOpenedSidebar(!TicketModule.openedSidebar);
			});
			break;
		case "pinned":
			TicketModule.ticketPinned(roomId);
			break;
		case "archived":
			TicketModule.ticketArchived(roomId);
			break;
	}
}

function openFile(el: { message: IMessage; file?: { url: string } }) {
	emits("previewMedia", { show: true, params: el });
}
function sendMessage(props: MessagePayload) {
	if (AuthModule.token) {
		lastMessageSending.value = true;
		MessageModule.sendMessage({
			...props,
			token: AuthModule.token,
			senderId: AuthModule.data.user?.id ?? "",
		});
	}
}
function filter(e: Filters) {
	const searchInput = document.getElementById(
		"search-room-input"
	) as HTMLInputElement;
	if (searchInput) searchInput.value = "";
	if (
		TicketModule.currentNewestRoom.id &&
		TicketModule.currentRoomId !== TicketModule.currentNewestRoom.id
	) {
		socket.emit("LEAVE_ROOM", {
			token: AuthModule.token,
			ticketID: TicketModule.currentRoomID,
		});
		TicketModule.previewOldTicket({
			ticketId: TicketModule.currentNewestRoom.id,
			setCurrRoom: false,
		});
	}
	TicketModule.resetConfig();
	TicketModule.setFilter(e);
	if (AuthModule.token && e === "closed" && TicketModule.Tickets.length === 0)
		TicketModule.requestPageTickets({
			token: AuthModule.token,
		});
}
function search(e: any) {
	const pattern = e.target.value.toLowerCase();
	const tickets = TicketModule.Tickets.filter(ticket => {
		return (
			ticket.subject.toLowerCase().includes(pattern) ||
			ticket.client[0].customer.name.toLowerCase().includes(pattern) ||
			ticket.client[0].identification.some(iden =>
				iden.toString().toLowerCase().includes(pattern)
			) ||
			ticket.thread.toLowerCase().includes(pattern)
		);
	}).map(ticket => ticket._id);

	rooms.value = TicketModule.Rooms.filter(
		room => tickets.indexOf(room.roomId) > -1
	);
}

function saveMessage(data: { message: string; roomId: string }) {
	TicketModule.setTypingMessage({ roomId: data.roomId, message: data.message });
}

function startTicket() {
	const ticket = TicketModule.currentTicket;
	socket.emit("CREATE_TICKET", {
		token: AuthModule.token,
		client: ticket?.client[0]._id ?? "",
		channel: ticket?.channel._id ?? "",
	});
	TicketModule.setFilter(Filters.CLAIMED);
	TicketModule.resetConfig();
}

function activePrivateReply({ roomId = "", status = false }) {
	TicketModule.setPrivateReplyStatus({ roomId, status });
}

watch(
	() => [MessageModule.CurrentMessage],
	() => {
		const message = MessageModule.CurrentMessage
			? MessageModule.CurrentMessage
			: TicketModule.typingMessage;
		if (textareaRef.value) {
			textareaRef.value.value = message ?? "";

			const padding = window
				.getComputedStyle(textareaRef.value, null)
				.getPropertyValue("padding-top")
				.replace("px", "");

			textareaRef.value.style.height = "0";
			textareaRef.value.style.height =
				textareaRef.value.scrollHeight - parseInt(padding) * 2 + "px";

			setTimeout(() => {
				textareaRef.value?.focus();
				const event = new Event("input");
				textareaRef.value?.dispatchEvent(event);
			});
		}
	}
);

watch(() => [route.params.option], setFilter);

watch(
	() => [TicketModule.Rooms],
	() => {
		rooms.value = TicketModule.Rooms;
	}
);

watch(
	() => [MessageModule.ShowUpperLoader],
	() => {
		setTimeout(() => {
			const LoaderTopRef = document.getElementById("infinite-loader-messages");
			if (MessageModule.ShowUpperLoader) {
				if (LoaderTopRef && observer.value)
					observer.value.observe(LoaderTopRef);
			}
		});
	}
);

watch(
	() => [TicketModule.currentTicket, TicketModule.currentRoomID],
	() => {
		if (
			MessageModule.lastMessage?._id ===
				TicketModule.currentTicket?.last_msg._id &&
			TicketModule.currentRoomID === TicketModule.currentNewestRoom.id
		) {
			lastMessageSending.value = false;
			autoScrollOptions.send.new = true;
			autoScrollOptions.receive.new = true;
		}
		MessageModule.refreshCurrentMessage(TicketModule.typingMessage ?? "");
	}
);

watch(
	() => [MessageModule.lastMessage],
	() => {
		setTimeout(() => {
			if (TicketModule.currentRoomID !== null && showBottomLoader.value) {
				if (LoaderBottomRef.value && observer.value)
					observer.value.observe(LoaderBottomRef.value);
			}
		});
	}
);

watch(
	() => [TicketModule.currentRoomID],
	() => {
		if (TicketModule.currentRoomID !== TicketModule.CurrentNewestRoom.id) {
			autoScrollOptions.send.new = false;
			autoScrollOptions.receive.new = false;
		}

		if (TicketModule.Filter === Filters.CLOSED && TicketModule.currentRoomID) {
			coreApi.defaults.headers.common["access-token"] = AuthModule.token ?? "";
			coreApi
				.post(`api/ticket/search/last/${TicketModule.currentRoomID}`)
				.then(response => {
					reopenTicket.value =
						response.data.ticket === TicketModule.currentRoomID;
				});
		}
	}
);

onMounted(() => {
	const element = document.getElementById(
		"roomTextarea"
	) as HTMLTextAreaElement;
	textareaRef.value = element;

	const messageContainer = document.getElementById("messages-list");
	if (messageContainer) observer.value = messageListObserver(messageContainer);
	setFilter();
	// console.log('==============> actual ticket id: ', TicketModule.currentRoomID)
	if (
		route.params.option === "overview" &&
		route.query.ticket &&
		AuthModule.token
	) {
		MessageModule.requestTicketsFromClient({
			ticketId: route.query.ticket as string,
			client: route.query.client as string,
			token: AuthModule.token,
			limit: route.query.limit ? parseInt(route.query.limit as string) : 15,
			page: route.query.page ? parseInt(route.query.page as string) : 1,
		});
	} else if (route.query.ticket)
		TicketModule.setActualRoom(route.query.ticket as string);
});

function switchControl() {
	if (
		TicketModule.currentTicket?.channel.interface === "COMMENT_INTERFACE" &&
		!TicketModule.currentTicket?.private_replied &&
		!TicketModule.currentTicket.public_replied
	)
		activePrivateReply({
			roomId: TicketModule.currentRoomId ?? "",
			status: !privateReplyStatus.value,
		});
	else ConversationModule.setActive(true);
}
onUnmounted(() => {
	MessageModule.deleteAllMessages();
	TicketModule.clearTickets();
	observer.value?.disconnect();
});

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(ChatWindow, {
    "current-user-id": _unref(currentUserId),
    rooms: (rooms.value as Room[]),
    messages: _unref(messages),
    height: _unref(height),
    "messages-loaded": _unref(MessageModule).allMessagesLoaded,
    "room-id": _unref(TicketModule).currentRoomID?.toString(),
    "loading-rooms": _unref(TicketModule).Loading,
    "rooms-loaded": _unref(TicketModule).loaded,
    "rooms-order": "asc",
    "text-messages": _unref(textMessages),
    "show-footer": 
			_unref(showFooter) &&
			_unref(TicketModule).currentRoom?.newestRoom &&
			!_unref(TicketModule).disableCommentReplies
		,
    "scroll-distance": 60,
    "auto-scroll": _unref(autoScrollOptions),
    "menu-actions": _unref(roomActions),
    onMenuActionHandler: actionHandler,
    onFetchMessages: fetchMessages,
    onFetchMoreRooms: fetchRooms,
    onSendMessage: sendMessage,
    onTextareaActionHandler: switchControl,
    onTypingMessage: saveMessage,
    "load-first-room": false,
    "textarea-action-enabled": 
			_unref(ConversationModule).showToggle ||
			(_unref(TicketModule).currentTicket?.channel.interface === 'COMMENT_INTERFACE' &&
				!_unref(TicketModule).currentTicket?.private_replied)
		
  }, _createSlots({
    "rooms-list-search": _withCtx(() => [
      _createVNode(RoomSearch, {
        "show-add-room": _unref(TicketModule).Filter === 'claimed',
        "show-search": true,
        "text-messages": _unref(textMessages).SEARCH,
        onAddRoom: _cache[0] || (_cache[0] = () => emits('changeModalStartTicket', { show: true })),
        onSearchRoom: search,
        onFilterRoom: filter
      }, null, 8, ["show-add-room", "text-messages"])
    ]),
    "room-list-item": _withCtx(({ room }) => [
      _createVNode(RoomItem, {
        room: room,
        "current-user-id": _unref(currentUserId),
        "room-actions": _unref(roomActions),
        onRoomActionHandler: actionHandler
      }, {
        "room-list-avatar": _withCtx((props) => [
          _createElementVNode("div", {
            class: "vac-avatar d-flex align-items-center justify-content-center",
            style: _normalizeStyle({
							background: props.room.avatar
								? `url('${props.room.avatar}')`
								: props.room.color,
							backgroundSize: 'cover',
							backgroundPosition: 'center center',
						})
          }, [
            (!props.room.avatar)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(_unref(getInitials)(props.room.roomName, props.room.users[0].username)), 1))
              : _createCommentVNode("", true)
          ], 4)
        ]),
        "room-list-item-date": _withCtx((props) => [
          _createVNode(DetailTicket, {
            timestamp: (props.room.lastMessage?.timestamp as string),
            "social-network": (props.room.interface as any),
            pinned: props.room.pinned,
            "last-message-client": props.room.lastMessage?.origin === 'client'
          }, null, 8, ["timestamp", "social-network", "pinned", "last-message-client"])
        ]),
        _: 2
      }, 1032, ["room", "current-user-id", "room-actions"])
    ]),
    message: _withCtx((props) => [
      _createVNode(Message, {
        "message-actions": 
					props.message?.files?.some((f) => /mp3|oga|audio/i.test(f.type))
						? [{ name: 'downloadMedia', title: 'Descargar' }]
						: []
				,
        message: props.message,
        "current-user-id": _unref(currentUserId),
        messages: _unref(messages),
        "room-users": _unref(roomUsers),
        "new-messages": [],
        "show-reaction-emojis": true,
        "show-new-messages-divider": true,
        onOpenFile: openFile,
        onMessageActionHandler: messageActionHandler
      }, null, 8, ["message-actions", "message", "current-user-id", "messages", "room-users"])
    ]),
    "bottom-loader": _withCtx(() => [
      (_unref(showBottomLoader) && _unref(TicketModule).Filter === 'claimed')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            id: "infinite-loader-bottom-messages",
            ref_key: "LoaderBottomRef",
            ref: LoaderBottomRef
          }, [
            _createVNode(Loader, {
              show: true,
              infinite: true
            })
          ], 512))
        : (_openBlock(), _createElementBlock("div", _hoisted_2))
    ]),
    "rooms-empty": _withCtx(() => [
      _hoisted_3
    ]),
    _: 2
  }, [
    (_unref(TicketModule).Filter === 'closed')
      ? {
          name: "footer-buttons",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_base_button, {
                type: "danger",
                size: "sm",
                style: {"min-width":"150px"},
                disabled: true
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              (reopenTicket.value)
                ? (_openBlock(), _createBlock(_component_base_button, {
                    key: 0,
                    type: "success",
                    size: "sm",
                    style: {"min-width":"150px"},
                    onclick: startTicket
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        }
      : (_unref(TicketModule).Filter === 'archived')
        ? {
            name: "footer-buttons",
            fn: _withCtx(() => [
              _createElementVNode("div", { class: "my-2 d-flex justify-content-center" }, [
                _createVNode(_component_base_button, {
                  type: "warning",
                  size: "sm",
                  style: {"min-width":"150px"},
                  disabled: true
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Este ticket se encuentra archivado ")
                  ]),
                  _: 1
                })
              ])
            ])
          }
        : (!_unref(showFooter) && _unref(TicketModule).Filter === 'overview')
          ? {
              name: "footer-buttons",
              fn: _withCtx(() => [
                _createElementVNode("div", { class: "my-2 d-flex justify-content-center" }, [
                  _createVNode(_component_base_button, {
                    disabled: "",
                    type: "warning",
                    size: "sm",
                    style: {"min-width":"150px"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Modo solo vista ")
                    ]),
                    _: 1
                  })
                ])
              ])
            }
          : (!_unref(showFooter) && _unref(TicketModule).Filter !== 'claimed')
            ? {
                name: "footer-buttons",
                fn: _withCtx(() => [
                  _createElementVNode("div", { class: "my-2 d-flex justify-content-center" }, [
                    _createVNode(_component_base_button, {
                      type: "success",
                      size: "sm",
                      style: {"min-width":"150px"},
                      onclick: claimTicket
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Reclamar Ticket ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              }
            : (!_unref(TicketModule).currentRoom?.newestRoom)
              ? {
                  name: "footer-buttons",
                  fn: _withCtx(() => [
                    _createElementVNode("div", { class: "my-2 d-flex justify-content-center" }, [
                      _createVNode(_component_base_button, {
                        type: "primary",
                        size: "sm",
                        style: {"min-width":"150px"},
                        onclick: setNewestTicket
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Volver al ticket actual ")
                        ]),
                        _: 1
                      })
                    ])
                  ])
                }
              : (_unref(TicketModule).disableCommentReplies)
                ? {
                    name: "footer-buttons",
                    fn: _withCtx(() => [
                      _createElementVNode("div", { class: "my-2 d-flex justify-content-center" }, [
                        _createVNode(_component_base_button, {
                          type: "danger",
                          size: "sm",
                          style: {"min-width":"150px"},
                          onclick: 
						() => {
							_unref(closeTicket)(_unref(TicketModule).currentRoomID);
						}
					
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Cerrar ticket ")
                          ]),
                          _: 1
                        }, 8, ["onclick"])
                      ])
                    ])
                  }
                : (_unref(ConversationModule).showControl && _unref(TicketModule).currentRoomID)
                  ? {
                      name: "footer-buttons",
                      fn: _withCtx(() => [
                        _createVNode(TemplatesControl)
                      ])
                    }
                  : undefined,
    (_unref(ConversationModule).showToggle)
      ? {
          name: "custom-action-icon",
          fn: _withCtx(() => [
            _hoisted_7
          ])
        }
      : {
          name: "custom-action-icon",
          fn: _withCtx(() => [
            _createVNode(_component_el_tooltip, {
              class: "box-item",
              effect: "dark",
              content: 
					_unref(privateReplyStatus) || _unref(TicketModule).currentTicket.public_replied
						? 'Haz clic para desactivar la respuesta privada.'
						: 'Haz clic para activar la respuesta privada.'
				,
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: "fab fa-facebook-messenger comment-font",
                  style: _normalizeStyle(
						_unref(privateReplyStatus) || _unref(TicketModule).currentTicket.public_replied
							? { color: `var(--chat-bg-color-button)` }
							: { color: `var(--chat-color-placeholder)` }
					)
                }, null, 4)
              ]),
              _: 1
            }, 8, ["content"])
          ])
        },
    (
				_unref(TicketModule).Filter === 'closed' ||
				_unref(TicketModule).Filter === 'archived' ||
				_unref(TicketModule).Filter === _unref(Filters).BOT
			)
      ? {
          name: "room-options",
          fn: _withCtx(() => [
            _createVNode(RoomOptions, {
              "menu-actions": _unref(roomActions),
              "menu-actions-handler": actionHandler,
              "show-search": false
            }, null, 8, ["menu-actions"])
          ])
        }
      : {
          name: "room-options",
          fn: _withCtx(() => [
            _createVNode(RoomOptions, {
              "menu-actions": _unref(roomActions),
              "menu-actions-handler": actionHandler,
              "show-search": true
            }, null, 8, ["menu-actions"])
          ])
        }
  ]), 1032, ["current-user-id", "rooms", "messages", "height", "messages-loaded", "room-id", "loading-rooms", "rooms-loaded", "text-messages", "show-footer", "auto-scroll", "menu-actions", "textarea-action-enabled"]))
}
}

})